exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-form-text {\n  display: flex;\n  align-items: center;\n  background: #f5f7f9;\n  border: 1px solid #cad0d7;\n  border-radius: 8px;\n  color: rgba(6, 38, 62, 0.74);\n  letter-spacing: 0.02em;\n  min-height: 32px;\n  padding: 4px 12px 4px 12px;\n  font-size: 0.9rem;\n}\n.text-department {\n  font-size: 0.85rem;\n  color: rgba(6, 38, 62, 0.64);\n  margin-top: -1px;\n}\n#total-distance {\n  background-color: #f5f7f9;\n}\n", ""]);

// exports
